var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"historique-visites-medicales"},[(_vm.showing_liste === true)?_c('div',[_c('ListeVisitesMedicales',{on:{"onClickVisite":_vm.switchToVisite}})],1):_c('div',[_c('RecapVisitesMedicales',{attrs:{"visite":_vm.selected_visite},on:{"onClickBackToList":_vm.switchToVisite}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }